import React, { memo, useState } from "react";
import { useGetPatientQuestionsQuery } from "../../../../../services/chatService";
import { PlusIcon } from "@heroicons/react/20/solid";
import ReportProblemCard from "./ReportProblemCard";
import LoadingBars from "../../../../../components/loadingBar";
import { useForm } from "react-hook-form";
import AddProblemDialogue from "./AddProblemDialogue";
import Toggle from "../../../../../components/Toggle";
import Tooltip from "../../../../../components/Tooltip";
function ReportAProblem() {
  const { control } = useForm();

  const [showAddProblemDialogue, setShowAddProblemDialogue] = useState(false);
  const [selectedProblem, setSelectedProblem] = useState(null);
  const [showActiveProblems, setShowActiveProblems] = useState(true);
  const [loading, setLoading] = useState(false);

  const { data: patientProblems, isLoading: loadingProblems, refetch: refetchProblems } = useGetPatientQuestionsQuery({ deactivated_problems: !showActiveProblems ? 1 : 0 });

  return (
    <div>
      {showAddProblemDialogue && (
        <AddProblemDialogue
          showAddProblemDialogue={showAddProblemDialogue}
          setShowAddProblemDialogue={setShowAddProblemDialogue}
          selectedProblem={selectedProblem}
          setSelectedProblem={setSelectedProblem}
        />
      )}
      <div className="flex w-full items-center justify-between px-4 shadow-lg h-[55px]">
        <p className="text-[14px] font-bold">Report A Problem</p>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <p>Inactive</p>
            <Tooltip content="Toggle Active Problems" position="top">
              <Toggle
                isOn={showActiveProblems}
                onToggle={async (e) => {
                  setShowActiveProblems(e.target.checked);
                    setLoading(true);
                    refetchProblems().finally(() => {
                      setLoading(false);
                    });
                }}
                name={`problem_active_toggle`}
                className="cursor-pointer"
              />
            </Tooltip>
            <p>Active</p>
          </div>
          <button
            className="flex whitespace-nowrap cursor-pointer bg-ethizo_primary items-center text-white pl-2 pr-3  py-1 rounded-md shadow-md hover:shadow-lg"
            title="Add Problem"
            aria-label="Add Problem"
            onClick={() => setShowAddProblemDialogue(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setShowAddProblemDialogue(true);
              }
            }}
          >
            <PlusIcon className="h-5 w-5 cursor-pointer" /> Add
          </button>
        </div>
      </div>
      <div
        className="flex flex-col gap-3 w-full items-start p-4"
        style={{ height: "calc(100vh - 145px)", maxHeight: "calc(100vh - 145px)", overflowY: "auto" }}
      >
        {(loadingProblems || loading) && <LoadingBars />}
        {!loadingProblems && !loading && patientProblems?.response?.data?.length > 0 && (
          <div className="flex items-center justify-end w-full gap-2">
            <p className="text-sm text-slate-400 italic">
              Total records: {patientProblems?.response?.data?.length}
            </p>
          </div>
        )}
        {!loadingProblems && !loading && patientProblems?.response?.data?.length === 0 && (
          <div className="flex items-start justify-center w-full">
            <p className="text-sm text-slate-400 italic">No records found</p>
          </div>
        )}
        {!loadingProblems && !loading && (patientProblems?.response?.data || []).map((problem, index) => (
          <ReportProblemCard
            problem={problem}
            control={control}
            setShowAddProblemDialogue={setShowAddProblemDialogue}
            setSelectedProblem={setSelectedProblem}
            index={index}
            key={problem?.id}
          />
        ))}
      </div>
    </div>
  );
}

export default memo(ReportAProblem);